<app-widget [widget-meta]="this.data" hidehelp="false">
    @if (profileService.profile$ | async; as profile) {
        @if ((pages.data$ | async); as pages) {
            @if (pages.Result?.Content; as content) {
                <div>
                    <div [innerHTML]="content"></div>
                </div>
                } @else {
                <div>
                    <p>We're sorry — no content is available for this page. Use the home icon to return to MyKE.</p>
                </div>
                }
            } @else {
            <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
        }
        } @else {
        <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
    }
    
    <loading-or-error #loadingOrError
                      [loadingWrapper]="pages"
                      [errorMessage]="'Oops! Looks like we can\'t get information for Pages!'">
    </loading-or-error>
</app-widget>

